import "./styles.less";

import { Col, Typography } from "antd";
import React, { ReactElement, memo, useContext } from "react";

import { TextForm } from "./TextForm/web";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { OwnerInfo } from "../OwnerInfo/web";
import { BoxArrowIcon } from "shared-components/Components/CustomIcons/BoxArrowIcon/web";
import { getInmoLink } from "src/utils/Functions";
import { Owner as OwnerType } from "shared-components";
import { ButtonsLeadsSource } from "./TextForm/type";
import { FormCallToActions, useContactModal } from "shared-components/Contexts/ContactModal/context";

interface InformationRequestProps {
	id: number | string;
	children?: ReactElement;
	onComplete?: () => void;
	disabled?: boolean;
	defaultMessage?: string;
	isInListing?: boolean;
	showCTA?: boolean;
	queryRouter?: string;
	isProjectSpecialPage?: boolean;
	slug?: string;
	owner?: OwnerType;
	inmoPropsLink?: string;
	isProject?: boolean;
	isFromModal?: boolean;
	autoFocus?: boolean;
	source?: ButtonsLeadsSource;
	isExpress?: boolean;
	expressCallback?: (event: Event) => void
	propertyLink?: string;
	ctaToShow?: FormCallToActions
}

export const InformationRequest = memo(
	({
		id,
		children,
		onComplete = null,
		disabled = false,
		defaultMessage = "",
		isInListing = false,
		showCTA = false,
		queryRouter = "",
		isProjectSpecialPage = false,
		slug = "",
		owner = null,
		inmoPropsLink = undefined,
		isProject = false,
		isFromModal = false,
		autoFocus,
		source = "",
		isExpress = false,
		expressCallback = null,
		propertyLink = undefined,
		ctaToShow
	}: InformationRequestProps) => {
		const { country_code } = useContext(ConfigStateContext);
		const { ctaButtons } = useContactModal();
		const showTextInput = isExpress ? !isExpress : (((!ctaButtons?.phone && !ctaButtons?.whatsapp) && source === "contactModal") || source !== "contactModal")

		const redirectLink = country_code === 'CO' ? getInmoLink(owner?.id, owner?.name) : (inmoPropsLink ?? "")

		const children_holder = children ? (
			<Col span={24} lg={12}>
				{children}
				{owner?.type !== null && !owner?.particular && (
					<Typography.Link
						className="see-more-props"
						href={redirectLink}
						target="_blank">
						<span>Ver todas las propiedades</span>
						<BoxArrowIcon width={18} />
					</Typography.Link>
				)}
			</Col>
		) : <></>;

		const top_form =
			showCTA ? (
				<OwnerInfo
					owner={owner}
				/>
			) : null;

		return (
			<div className={`property-information-request ${children ? "grid" : ""}`}>
				{children_holder}

				<div className="property-information-request--content">
					{top_form}

					<TextForm
						id={Number(id)}
						onComplete={onComplete}
						defaultMessage={defaultMessage}
						disabled={disabled}
						isInListing={isInListing}
						queryRouter={queryRouter}
						isProjectSpecialPage={isProjectSpecialPage}
						slug={slug}
						isProject={isProject}
						isExpress={isExpress}
						owner={owner}
						isFromModal={isFromModal}
						autoFocus={autoFocus}
						showTextInput={showTextInput}
						expressCallback={expressCallback}
						source={source}
						propertyLink={propertyLink}
						ctaToShow={ctaToShow}
					/>
				</div>
			</div>
		);
	}
);

